// extracted by mini-css-extract-plugin
export default {"wrapper":"side-menu_wrapper__TQgKg","text":"side-menu_text__sCPIR","cursor":"side-menu_cursor__XNS9V","bgHighlight":"side-menu_bgHighlight__H9clp","close":"side-menu_close__shyKL"};